import { gql } from '@apollo/client';
import {
  CreatorFields,
  EditorFields,
  LogicalOperatorFragment,
  RelationalOperatorFragment,
  SchemaFieldsFragment,
} from '../fragments';
import {
  FieldFieldsFragment,
  BasicFieldValueFragment,
  AnyFieldValueFragment,
} from '../fields';
import { EntityCategoryFragment } from '../entityCategories';

export const OperandsFragment = gql`
  fragment OperandsFields on Operands {
    ... on ValueOperands {
      values {
        ... on BasicFieldValue {
          ...BasicFieldValueFields
        }
        ... on AnyFieldValue {
          ...AnyFieldValueFields
        }
      }
    }
    ... on FieldOperands {
      fields {
        ...FieldFields
      }
    }
  }
  ${FieldFieldsFragment}
  ${BasicFieldValueFragment}
  ${AnyFieldValueFragment}
`;

const SimplePredicateFieldsFragment = gql`
  fragment SimplePredicateFields on SimplePredicate {
    field {
      ...FieldFields
    }
    relOp {
      ...RelationalOperatorFields
    }
    operands {
      ...OperandsFields
    }
    matchCase
  }
  ${FieldFieldsFragment}
  ${OperandsFragment}
  ${RelationalOperatorFragment}
`;

const ArrayObjectPredicateFieldsFragment = gql`
  fragment ArrayObjectPredicateFields on ArrayObjectPredicate {
    elementPredicates {
      ...SimplePredicateFields
    }
  }
  ${SimplePredicateFieldsFragment}
`;

export const PredicateFieldsFragment = gql`
  fragment PredicateFields on Predicate {
    ... on SimplePredicate {
      ...SimplePredicateFields
    }
    ... on ArrayObjectPredicate {
      ...ArrayObjectPredicateFields
    }
  }
  ${SimplePredicateFieldsFragment}
  ${ArrayObjectPredicateFieldsFragment}
`;

export const ConditionFragment = gql`
  fragment ConditionFields on Condition {
    predicates {
      ...PredicateFields
    }
    logicOps {
      ...LogicalOperatorFields
    }
  }
  ${LogicalOperatorFragment}
  ${PredicateFieldsFragment}
`;

const BasicFilterFragment = gql`
  fragment BasicFilterFields on BasicFilter {
    type
    conditions {
      ...ConditionFields
    }
    logicOps {
      ...LogicalOperatorFields
    }
  }
  ${ConditionFragment}
  ${LogicalOperatorFragment}
`;

export const NamedFilterFragment = gql`
  fragment NamedFilterFields on NamedFilter {
    type
    id
    name
    description
    version
    comment
    isLatestVersion
    isDisabled
    creator {
      ...CreatorFields
    }
    createdAt
    editor {
      ...EditorFields
    }
    editedAt
    schema {
      ...SchemaFields
    }
    conditions {
      ...ConditionFields
    }
    logicOps {
      ...LogicalOperatorFields
    }
    categories {
      ...EntityCategoryFields
    }
    isFavorite
    isManaged
  }
  ${CreatorFields}
  ${EditorFields}
  ${SchemaFieldsFragment}
  ${ConditionFragment}
  ${LogicalOperatorFragment}
  ${EntityCategoryFragment}
`;

export const FilterFragment = gql`
  fragment FilterFields on Filter {
    ... on BasicFilter {
      ...BasicFilterFields
    }
    ... on NamedFilter {
      ...NamedFilterFields
    }
  }
  ${BasicFilterFragment}
  ${NamedFilterFragment}
`;
